import { Button, Collapse, Fade, Flex, Image, Text, useDisclosure } from '@chakra-ui/react';
import Axios from 'axios';
import React, { useEffect } from 'react';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import Header from '../../../components/Header';
import { baseURL } from '../../../services/api';
import { FiltroPedidos } from '../../Devolucoes/FiltroPedidos';
import { TableUsage } from '../../Devolucoes/Table';
const loading_verde = '../../images/loading-verde.gif';

const AcompanhaCompras = () => {
  const [loading, setLoading] = useState(false);
  const [infos, setInfos] = useState([]);

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting, isDirty }
  } = useForm();
  const [ordered, setOrdered] = useState(false);

  async function submitForm(data) {
    setLoading(true);
    try {
      const response = await baseURL.post('/pedido/acompanhamento-compras' + '', data);
      const sortedData = response.data.sort(
        (a, b) => new Date(b.data_saida_mercadoria) - new Date(a.data_saida_mercadoria)
      );
      console.log(response);

      setInfos(sortedData);
      setLoading(false);
      console.log(response);
    } catch (error) {
      console.log(Object.keys(error), error.message);
      setLoading(false);
    }

    console.log(data);
  }

  useEffect(() => {
    submitForm({ pendente: '' });
  }, []);

  const counterNumPed = infos.filter(
    (item, index, self) => self.findIndex((t) => t.numinno === item.numinno) === index
  ).length;

  return (
    <>
      <Flex flexDir="column">
        <Text
          paddingBlock="2rem"
          bg="#378BBF"
          textAlign="center"
          fontSize="1.2rem"
          color="white"
          fontWeight="bold">
          Acompanhamento de Compras
        </Text>

        <FiltroPedidos
          isAcompanhaCompras
          register={register}
          handleSubmit={handleSubmit}
          submitForm={submitForm}
          errors={errors}
          isSubmitting={isSubmitting}
        />
        <Text fontSize="1.2rem" fontWeight="bold" color="#606163" marginLeft={'1rem'} mb={'1rem'}>
          {counterNumPed} Pedidos - {infos?.length} Itens
        </Text>
        {loading ? (
          <Flex w="100%" h="calc(100vh - 600px)" bgColor="white">
            <Image m="auto auto" w="auto" h="100px" src={loading_verde} />
          </Flex>
        ) : (
          <TableUsage
            setLoading={setLoading}
            infos={infos}
            isAcompanhaCompras={true}
            submitForm={submitForm}
          />
        )}
      </Flex>
    </>
  );
};

export default AcompanhaCompras;
